const en = {
  i18nView: {
    login: 'Login',
    account: 'Account',
    mainTip: 'After you open the Forget Mode, all the resouces will be paid by TokenPocket, then you can enjoy the wallet and forget CPU and NET',
    remainCount: 'Remain Operation Fee',
    status: 'Status',
    buyTimes: 'Top Up',
    pay: 'Pay',
    times: 'Times',
    buy: 'Buy',
    betaTip: 'Each account can purchase up to 6 CNY every day',
    success: 'Success!',
    claimSuccess: 'Success!',
    currentFee: 'Current Fee Rate',
    radioTips: 'The cost of each operation depends on the CPU time consumed by the transaction. One transfer transaction between two ordinary accounts consumes about 0.3 ms',
    ramTips: 'The first time active the Forget Mode, a small amount of RAM will be consumed. If the memory is insufficient, it will be purchased automatically',
    quotaTips: "When the resources are less than",
    quotaTips1: "please supplement the resource fee in time to avoid operation failure",
    overThreshold: 'The order exceeds the  limitation eachday ',
    copied: 'Copy success',
    copiedFailed: 'Copy failed',
    pleaseView: 'Please open in',
    activeFun: '',
    rechargeAccount: 'Recharge Account',
    self: 'Self',
    other: 'Other',
    inputAccount: 'Input account name',
    aboutMode: 'About Forget Mode',
    referRule: 'Referral Rules',
    referRule1: 'Invite your friend to use [Forget Mode] through your referral link and receive a 10% commission from theirs consuming in EOS/TPT of the [Forget Mode] in the first 3 months. The commission needs to be claimed manually.',
    referRule2: 'If B is the inviter of A,  but A bought resources through the referral link of C, then B and C will receive 4% and 6% commission.',
    referRule4: 'You need to consuming once after this update before you invite your friends. And you can only claim your reward when it reaches 1 EOS or 1 TPT',
    claimRefer: 'Claim',
    youhaveRefer: 'You have invited',
    yourReward: 'your commission',
    copy: 'Copy',
    referTitle: 'Referrals',
    rightTip: 'TokenPocket reserves the right to interpret these rules',
    pay: 'Pay',
    payTipsPart1: 'About transfer',
    payTipsPart2: 'times',
    whatisForget: 'What’s the Forget Mode?',
    whatisForget1: 'Every action on the EOS mainnet requires the resources (CPU and NET), which is complicated and bother users. Thus we launch the Forget Mode where users can easily execute the actions on the mainnet by paying a few fees, to erase the concept of CPU and NET.',
    gift: 'New User Gift',
    giftTip1: 'The EOS accounts that register after Dec 9th are eligible to receive a <em>10ms</em> CPU resources for free which can perform about <em>30</em> times token transfer. Other EOS accounts can receive a 5ms CPU resources for free.',
    openintp: 'Please claim it on TokenPocket',
    claimAndOpen: 'Claim and turn on the Forget Mode',
    claimed: 'Claimed',
    whereis: 'Where is the entrance? ',
    whereisTip: 'Please tap the “Lightning” button on the top of the Asset page to entry the Forget Mode where you can turn it on/off and top up resources. Also, you can invite friends and earn rewards.',
    forgetPro: 'Forget Mode PRO',
    forgetProTip: 'TokenPocket provides a solution for the DApps that want to cover resource fees for users. Users can play the DApps that have adopted this solution without CPU cost, don\'t need the Forget Mode too. Tap the following DApps to play',
    share: 'Share'
  }
};

export default en;